module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-355.1bef4fd.woff2";